import React from "react";

/**
 * Re-usable section heading. Eyebrow + title + optional sub.
 */
export default function SectionHeading({
    eyebrow,
    title,
    titleItalic,
    sub,
    align = "left",
    light = false,
    children,
}) {
    const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
    return (
        <div className={`max-w-3xl ${alignCls}`}>
            {eyebrow && <p className="ssh-eyebrow">{eyebrow}</p>}
            <h2
                className={`mt-5 font-serif font-light tracking-tight leading-[1.05] text-3xl sm:text-4xl lg:text-5xl ${
                    light ? "text-white" : "text-[#2C2B29]"
                }`}
            >
                {title}{" "}
                {titleItalic && (
                    <em
                        className={`italic font-light ${
                            light ? "text-[#EFEBE4]" : "text-[#A68A6B]"
                        }`}
                    >
                        {titleItalic}
                    </em>
                )}
            </h2>
            {sub && (
                <p
                    className={`mt-6 text-base sm:text-lg leading-relaxed ${
                        light ? "text-[#EFEBE4]" : "text-[#4A4947]"
                    } max-w-2xl ${align === "center" ? "mx-auto" : ""}`}
                >
                    {sub}
                </p>
            )}
            {children}
        </div>
    );
}
